import {BaseTerms} from "../../infrastructure/models/base-terms";

export class RelatedEntitiesWidgetTerms extends BaseTerms {}
